import { api } from '../api';

// Unwrap the {success, data} envelope to the inner DTO.
const unwrap = (r) => r?.data ?? r;

/**
 * Deal Desk — quotes + sales (M7).
 *
 * Money crosses the wire in integer cents (matches the backend). The builder
 * UI converts to/from dollars for display.
 */
export default {
  // ── quotes ──────────────────────────────────────────────────────────────
  list:    (params)    => api.get('/v1/quotes', { params }).then((r) => r.data),
  get:     (id)        => api.get(`/v1/quotes/${id}`).then((r) => unwrap(r.data)),
  create:  (body)      => api.post('/v1/quotes', body).then((r) => unwrap(r.data)),
  update:  (id, body)  => api.put(`/v1/quotes/${id}`, body).then((r) => unwrap(r.data)),
  addLine: (id, line)  => api.post(`/v1/quotes/${id}/lines`, line).then((r) => unwrap(r.data)),
  removeLine: (id, lineId) => api.delete(`/v1/quotes/${id}/lines/${lineId}`).then((r) => unwrap(r.data)),
  send:    (id)        => api.post(`/v1/quotes/${id}/send`).then((r) => unwrap(r.data)),
  accept:  (id)        => api.post(`/v1/quotes/${id}/accept`).then((r) => unwrap(r.data)),
  decline: (id, reason) => api.post(`/v1/quotes/${id}/decline`, { reason }).then((r) => unwrap(r.data)),
  cancel:  (id)        => api.post(`/v1/quotes/${id}/cancel`).then((r) => unwrap(r.data)),

  /** URL for the server-rendered PDF (opened in a new tab / embedded). */
  pdfUrl:  (id)        => `${api.defaults.baseURL}/v1/quotes/${id}/pdf`,
  /** Fetch the PDF as a Blob (carries the bearer token via the axios client). */
  pdfBlob: (id)        => api.get(`/v1/quotes/${id}/pdf`, { responseType: 'blob' }).then((r) => r.data),

  // ── sales ───────────────────────────────────────────────────────────────
  completeSale: (body) => api.post('/v1/sales', body).then((r) => unwrap(r.data)),
  listSales:    (params) => api.get('/v1/sales', { params }).then((r) => r.data),
  getSale:      (id)   => api.get(`/v1/sales/${id}`).then((r) => unwrap(r.data)),
  salesForLead: (leadId) => api.get(`/v1/sales/lead/${leadId}`).then((r) => unwrap(r.data)),
  deliverSale:  (id)   => api.post(`/v1/sales/${id}/deliver`).then((r) => unwrap(r.data)),
  cancelSale:   (id, reason) => api.post(`/v1/sales/${id}/cancel`, { reason }).then((r) => unwrap(r.data)),
};
